"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseClass_1 = __importDefault(require("./BaseClass"));
/**
 * Admin Tool class contain APIs related to control our system
 * @public
 */
class AdminTool extends BaseClass_1.default {
    constructor(apiV1, apiV2) {
        super(apiV1, apiV2);
    }
    /**
     * Function to get list service marketplace
     * @param sort - field and order to sort. Eg: { name: 'asc' } | { createdAt:'asc' }
     * @param page - page number
     * @param limit - limit number
     * @returns Return list service marketplace data
     */
    async getListMarketplace(sort, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListMarketplace(page, limit, sort);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to service marketplace detail
     * @param serviceId - serviceId
     * @returns Return service marketplace detail
     */
    async detailMarketplace(serviceId) {
        try {
            const data = await this._apiV2.adminTool.detailMarketplace(serviceId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update service marketplace
     * @param serviceId - serviceId
     * @param updateData - object contain field to update
     * @returns Return service marketplace updated
     */
    async updateMarketplace(serviceId, updateData) {
        try {
            const data = await this._apiV2.adminTool.updateMarketplace(serviceId, updateData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list news
     * @param sort - field and order to sort. Eg: { name: 'asc' } | { 'createdAt': desc }
     * @param page - page number
     * @param limit - limit number
     * @returns List news
     */
    async getListNews(sort, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListNews(page, limit, sort);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to create news
     * @param newsData - object contain fields to create
     * @returns News record just created
     */
    async createNews(newsData) {
        try {
            const data = await this._apiV2.adminTool.createNews(newsData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update news info
     * @param newsId - news Id
     * @param updateData - object contain fields to update
     * @returns News record just updated
     */
    async updateNews(newsId, updateData) {
        try {
            const data = await this._apiV2.adminTool.updateNews(newsId, updateData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list service certificates
     * @param sort - field and order want to sort. Eg: { name: 'asc' } | { 'createdAt': desc }
     * @param query - criteria for filtering certificates
     * @param page - page number
     * @param limit - limit number
     * @returns List service certificates
     */
    async getListCertificates(sort, query, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListCertificates(page, limit, sort, query);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update service certificates
     * @param {ObjectId} certificateId - certificateId
     * @param {number} displayOrder - display order
     * @returns Certificates just updated
     */
    async updateCertificateDisplayOrder(certificateId, displayOrder) {
        try {
            const data = await this._apiV2.adminTool.updateCertificateDisplayOrder(certificateId, displayOrder);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list identity field
     * @param sort - field and order want to sort. Eg: { name: 'asc' } | { createdAt: 'desc' }
     * @param query - criteria for filtering identity
     * @param page - page number
     * @param limit - limit number
     * @returns List identity field
     */
    async getListIdentityField(sort, query, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListIdentityField(page, limit, sort, query);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to create identity field
     * @param identityFieldData - object contain fields to create
     * @returns IdentityField record just created
     */
    async createIdentityField(identityFieldData) {
        try {
            const data = await this._apiV2.adminTool.createIdentityField(identityFieldData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update identity field info
     * @param identityId - identity Id
     * @param updateData - object contain fields to update
     * @returns IdentityField record just updated
     */
    async updateIdentityField(identityId, updateData) {
        try {
            const data = await this._apiV2.adminTool.updateIdentityField(identityId, updateData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list group identity field
     * @param sort - field and order want to sort. Eg: { name: 'asc' } | { createdAt: 'desc' }
     * @param query - criteria for filtering group identity
     * @param page - page number
     * @param limit - limit number
     * @returns List group identity field
     */
    async getListGroupIdentityField(sort, query, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListGroupIdentityField(page, limit, sort, query);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to create group identity field
     * @param groupIdentityFieldData - object contain fields to create
     * @returns GroupIdentityField record just created
     */
    async createGroupIdentityField(groupIdentityFieldData) {
        try {
            const data = await this._apiV2.adminTool.createGroupIdentityField(groupIdentityFieldData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update group identity field info
     * @param groupIdentityId - group identity Id
     * @param updateData - object contain fields to update
     * @returns GroupIdentityField record just updated
     */
    async updateGroupIdentityField(groupIdentityId, updateData) {
        try {
            const data = await this._apiV2.adminTool.updateGroupIdentityField(groupIdentityId, updateData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list runtime config
     * @param query - criteria for filtering runtime config
     * @param page - page number
     * @param limit - limit number
     * @returns List runtime config
     */
    async getListRuntimeConfig(query, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListRuntimeConfig(page, limit, query);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get runtime config detail
     * @param key - keyword to query runtime config
     * @returns Runtime config detail
     */
    async getDetailRuntimeConfig(key) {
        try {
            const data = await this._apiV2.adminTool.getDetailRuntimeConfig(key);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to create new runtime config
     * @param runtimeConfigData - object contain fields to create
     * @returns RuntimeConfig record just created
     */
    async createRuntimeConfig(runtimeConfigData) {
        try {
            const data = await this._apiV2.adminTool.createRuntimeConfig(runtimeConfigData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update runtime config data
     * @param runtimeConfigId - runtimeConfig Id
     * @param updateData - object contain fields to update
     * @returns GroupIdentityField record just updated
     */
    async updateRuntimeConfig(runtimeConfigId, updateData) {
        try {
            const data = await this._apiV2.adminTool.updateRuntimeConfig(runtimeConfigId, updateData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to query user detail for debugger
     * @param query - keyword to query user detail, it can be user email or userId
     * @returns User detail
     */
    async queryUserDetailDebuggerTool(query) {
        try {
            const data = await this._apiV2.adminTool.queryUserDetailDebuggerTool(query);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to query user's tree history for debugger
     * @param userId - unique id of user
     * @returns User's tree history
     */
    async queryTreeHistoryDebuggerTool(userId) {
        try {
            const data = await this._apiV2.adminTool.queryTreeHistoryDebuggerTool(userId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to query user's service registered for debugger
     * @param userId - unique id of user
     * @returns User's registered service
     */
    async queryServiceRegisteredDebuggerTool(userId) {
        try {
            const data = await this._apiV2.adminTool.queryServiceRegisteredDebuggerTool(userId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to query user's register log for debugger
     * @param userId - unique id of user
     * @param serviceId - unique id of service
     * @param status - status
     * @returns User's register log
     */
    async queryRegisterLogDebuggerTool(userId, serviceId, status) {
        try {
            const data = await this._apiV2.adminTool.queryRegisterLogDebuggerTool(userId, serviceId, status);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to query user's submit log for debugger
     * @param userId - unique id of user
     * @param serviceId - unique id of service
     * @param status - status
     * @param registerLog - unique id of serviceRegistered record
     * @returns User's submit log
     */
    async querySubmitLogDebuggerTool(userId, serviceId, status, registerLog) {
        try {
            const data = await this._apiV2.adminTool.querySubmitLogDebuggerTool(userId, serviceId, status, registerLog);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to query user certificate for debugger
     * @param userId - unique id of user
     * @param serviceId - unique id of service
     * @param status - status
     * @returns User certificates
     */
    async queryUserCertificateDebuggerTool(userId, serviceId, status) {
        try {
            const data = await this._apiV2.adminTool.queryUserCertificateDebuggerTool(userId, serviceId, status);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to delete identity
     * @param email - user email want to delete
     * @param isDeleteWID - delete user data in WID or nor
     * @param isDeleteCore - delete user data in Core or nor
     * @param isDeleteAuth - delete user data in Auth or nor
     * @returns Identity record just deleted
     */
    async deleteIdentity(userId, isDeleteWID, isDeleteCore, isDeleteAuth) {
        try {
            const data = await this._apiV2.adminTool.deleteIdentity(userId, isDeleteWID, isDeleteCore, isDeleteAuth);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to delete bulk identity
     * @param emailList - List email want to delete, separated by commas
     * @returns String array, each item is jobId which performs delete identity
     */
    async deleteBulkIdentity(emailList) {
        try {
            const data = await this._apiV2.adminTool.deleteBulkIdentity(emailList);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list identity deleted
     * @param page - page number
     * @param limit - limit number
     * @param email - email to filtering identity deleted
     * @returns List identity deleted
     */
    async getListIdentityDeleted(page = 0, limit = 10, email) {
        try {
            const data = await this._apiV2.adminTool.getListIdentityDeleted(page, limit, email);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list job delete identity
     * @param page - page number
     * @param limit - limit per page
     * @returns List jobs delete identity
     */
    async getListJobDeleteIdentity(page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListJobDeleteIdentity(page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to recover identity deleted
     * @param recordId - unique id of deleted identity record
     * @returns empty response
     */
    async recoverIdentity(recordId) {
        try {
            const data = await this._apiV2.adminTool.recoverIdentity(recordId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to delete identityDeleted record
     * @param recordId - unique id of deleted identity record
     * @returns empty response
     */
    async deleteRecoverBin(recordId) {
        try {
            const data = await this._apiV2.adminTool.deleteRecoverBin(recordId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list billing stats
     * @param page - page number
     * @param limit - limit per page
     * @returns List billing stats
     */
    async getListBillingStats(page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListBillingStats(page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to generate billing stats report
     * @param page - page number
     * @param limit - limit per page
     * @returns Blob object -> It's csv content
     */
    async generateBillingStatsReport(startDate, endDate) {
        try {
            const data = await this._apiV2.adminTool.generateBillingStatsReport(startDate, endDate);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get billing service logs
     * @param query - object contain fields to filtering logs
     * @param page - page number
     * @param limit - limit per page
     * @returns List billing service logs
     */
    async getBillingServiceLogs(query, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getBillingServiceLogs(page, limit, query);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to check can use clientId to create link or not
     * @param {string} clientId service client Id
     * @returns Result that you know can use clientId to create link or not
     */
    async canUseClientIdToLink(clientId, serviceType) {
        try {
            const result = await this._apiV2.adminTool.checkCanUseClientIdToLink(clientId, serviceType);
            return result;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * [Deprecated] Function to get service link info
     * @param clientId - client Id of service
     * @returns ServiceLink data as format verify with page can use to display group of KYC vs KYB
     */
    async getServiceLinkInfo(clientId) {
        try {
            const data = await this._apiV2.adminTool.getServiceLinkInfo(clientId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * [Deprecated] Function to get list service link
     * @param query - criteria to filtering data
     * @param page - page number
     * @param limit - limit number
     * @returns Return list service link data
     */
    async getListServiceLink(query, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListServiceLink(page, limit, query);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * [Deprecated] Function to create service link
     * @param serviceLinkData - object contain fields to create
     * @returns ServiceLink record just created
     */
    async createServiceLink(serviceLinkData) {
        try {
            const data = await this._apiV2.adminTool.createServiceLink(serviceLinkData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * [Deprecated] Function to update service link
     * @param linkId - service link Id
     * @param updateData - object contain fields to update
     * @returns ServiceLink record just updated
     */
    async updateServiceLink(linkId, updateData) {
        try {
            const data = await this._apiV2.adminTool.updateServiceLink(linkId, updateData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * [Deprecated] Function to remove service link
     * @param linkId - service link Id
     * @returns Success or failure error
     */
    async removeServiceLink(linkId) {
        try {
            const data = await this._apiV2.adminTool.removeServiceLink(linkId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get verify-with config info
     * @param clientId - client Id of service (KYC ClientId or KYB ClientId)
     * @returns verify-with config data as a usable verify-with config page
     */
    async getVerifyWithConfigInfo(clientId) {
        try {
            const data = await this._apiV2.adminTool.getVerifyWithConfigInfo(clientId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list verify-with config
     * @param query - criteria to filtering data
     * @param page - page number
     * @param limit - limit number
     * @returns Return list verify-with config data
     */
    async getListVerifyWithConfigs(query, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListVerifyWithConfigs(page, limit, query);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to create new verify-with config
     * @param verifyWithConfig - object contain fields to create
     * @returns Verify-With config record just created
     */
    async createVerifyWithConfig(verifyWithConfig) {
        try {
            const data = await this._apiV2.adminTool.createVerifyWithConfig(verifyWithConfig);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update verify-with config
     * @param linkId - verifyWithConfig Id
     * @param updateData - object contain fields to update
     * @returns Verify-With config record just updated
     */
    async updateVerifyWithConfig(linkId, updateData) {
        try {
            const data = await this._apiV2.adminTool.updateVerifyWithConfig(linkId, updateData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to delete verify-with config
     * @param linkId - verifyWithConfig Id
     * @returns Success or failure error
     */
    async removeVerifyWithConfig(linkId) {
        try {
            const data = await this._apiV2.adminTool.removeVerifyWithConfig(linkId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list Blockpass member
     * @param email - user email
     * @param page - page number
     * @param limit - limit number
     * @returns
     */
    async getListBlockpassMember(email, page, limit) {
        try {
            const data = await this._apiV2.adminTool.getListBlockpassMember(email, page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list Blockpass Operator
     * @param email - user email
     * @param page - page number
     * @param limit - limit number
     * @param omitClientId - return all BpOperator but exclude person already exists in this service
     * @returns
     */
    async getListBlockpassOperator(email, page, limit, omitClientId) {
        try {
            const data = await this._apiV2.adminTool.getListBlockpassOperator(email, page, limit, omitClientId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to promote user to Blockpass Operator
     * @param userId - Id of user want to promote to BP Operator
     * @returns
     */
    async promoteBlockpassOperator(userId) {
        try {
            const data = await this._apiV2.adminTool.promoteBlockpassOperator(userId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to downgrade Blockpass Operator to normal user
     * @param userId - Id of BP Operator want to downgrade to normal user
     * @returns
     */
    async downgradeBlockpassOperator(userId) {
        try {
            const data = await this._apiV2.adminTool.downgradeBlockpassOperator(userId);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list Blockpass Operator in services
     * @param clientId - service clientId want to get list operators
     * @param page - page number
     * @param limit - limit number
     * @returns
     */
    async getListBlockpassOperatorInService(clientId, page, limit) {
        try {
            const data = await this._apiV2.adminTool.getListBlockpassOperatorInService(clientId, page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to add BP Operator to service
     * @param newBPOperatorInfo - object contain info to add BP Operator to service
     * @returns
     */
    async addNewBlockpassOperatorToService(newBPOperatorInfo) {
        try {
            const data = await this._apiV2.adminTool.addNewBlockpassOperatorToService(newBPOperatorInfo);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to update BP Operator role in service
     * @param udbpOperatorInfo - object contain info to update BP Operator in service
     * @returns
     */
    async updateBpOperatorRoleInService(updateBPOperatorInfo) {
        try {
            const data = await this._apiV2.adminTool.updateBpOperatorRoleInService(updateBPOperatorInfo);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to remove BP Operator from service
     * @param removeBPOperatorData - object contain info to remove BP Operator from service
     * @returns
     */
    async removeBlockpassOperatorFromService(removeBPOperatorData) {
        try {
            const data = await this._apiV2.adminTool.removeBlockpassOperatorFromService(removeBPOperatorData);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list KYC service
     * @param filter - filter by name or client_id. Eg: {name:'dev',client_id:'dev}
     * @param sort - field and order to sort. Eg: {name: 'asc',createdAt:'asc'}
     * @param page - page number
     * @param limit - limit number
     * @returns Return list service data
     */
    async getListKYCServiceOperatorAssignmentTool(filter = {}, sort, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListKYCServiceOperatorAssignmentTool(filter, sort, page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
    /**
     * Function to get list KYB service
     * @param filter - filter by name or client_id. Eg: {name:'dev',client_id:'dev}
     * @param sort - field and order to sort. Eg: {name: 'asc',createdAt:'asc'}
     * @param page - page number
     * @param limit - limit number
     * @returns Return list service data
     */
    async getListKYBServiceOperatorAssignmentTool(filter = {}, sort, page = 0, limit = 10) {
        try {
            const data = await this._apiV2.adminTool.getListKYBServiceOperatorAssignmentTool(filter, sort, page, limit);
            return data;
        }
        catch (error) {
            this._handleError(error);
        }
    }
}
exports.default = AdminTool;
